import React, { useState } from 'react';
import { Button, Spin } from 'antd';
import { ProfileComponent } from './ProfileComponent';
import ProfileFormContainer from './ProfileFormContainer';
import { useCamasysCustomer } from '../../../../../core-module/hooks';

interface Props {
  customer: any;
}

const ProfileTab: React.FC<Props> = ({ customer }) => {
  const [showProfileForm, setShowProfileForm] = useState(false);
  const camasysCustomerQuery = useCamasysCustomer(customer.id, showProfileForm);

  if (camasysCustomerQuery.loading) {
    return <Spin spinning={true}>Profiel aan het ophalen...</Spin>;
  }

  if (camasysCustomerQuery.error || !camasysCustomerQuery.camasysCustomer) {
    return <p>Er is een fout opgetreden bij het ophalen van het profiel.</p>;
  }

  const camasysCustomer = camasysCustomerQuery.camasysCustomer;
  return (
    <>
      {showProfileForm ? (
        <ProfileFormContainer
          customerId={customer.id}
          camasysCustomer={camasysCustomer}
          onHideClick={() => setShowProfileForm(false)}
        />
      ) : (
        <>
          <Button
            onClick={() => setShowProfileForm(true)}
            type='primary'
            icon='edit'
            style={{ marginBottom: 15 }}
          >
            Wijzig
          </Button>
          <ProfileComponent
            firstName={customer.first_name}
            lastName={customer.last_name}
            prefix={customer.prefix}
            customerNumber={customer.customer_id}
            camasysCustomer={camasysCustomer}
          />
        </>
      )}
    </>
  );
};

export { ProfileTab };
